import {ApolloClient} from 'apollo-client';
import {createUploadLink} from 'apollo-upload-client';
import {setContext} from 'apollo-link-context';
import {ApolloLink} from 'apollo-link';
import {InMemoryCache} from 'apollo-cache-inmemory';
import {onError} from 'apollo-link-error';
import config from '../config/app';
import {checkErrorType} from '../utils';
import {getAccessToken, logout} from '../utils';
import {ERROR_TYPE_AUTH_ERROR} from '../common/constants';

let apolloClient = null;

function create() {

  const httpLink = createUploadLink({
    uri: config.graphql.endpoint,
    credentials: 'same-origin',
  });


  const authLink = setContext((_, {headers}) => {
    const token = getAccessToken();
    return {
      headers: {
        ...headers,
        authorization: token ? `Bearer ${token}` : '',
      },
    };
  });

  const logoutLink = onError(({networkError, graphQLErrors}) => {
    let notAuthenticated = false;
    if (graphQLErrors && checkErrorType({graphQLErrors}, ERROR_TYPE_AUTH_ERROR)) {
      notAuthenticated = true;
    }
    if (networkError && networkError.statusCode === 401) {
      notAuthenticated = true;
    }
    // If the token become invalid, need to reset apollo cache and remove token
    if (notAuthenticated && getAccessToken() !== null) {
      logout(apolloClient);
    }
  });

  return new ApolloClient({
    link: ApolloLink.from([logoutLink, authLink, httpLink]),
    cache: new InMemoryCache({
      dataIdFromObject: o => {
        if (o.id) {
          return `${o.__typename}-${o.id}`;
        } else {
          console.warn(`No ID provided in the query object '${o.__typename}', will use cursor`);
          return `${o.__typename}-table-${o.cursor}`;
        }
      },
    }),
  });
}

export default function initApollo() {
  // Reuse client on the client-side
  if (!apolloClient) {
    apolloClient = create();
  }
  return apolloClient;
}
